<div class="advance-modal-backdrop" (click)="onBackdropClick($event)">
  <div class="advance-modal"
       [class.advance-modal--back]="isBack"
       role="dialog"
       aria-modal="true"
       aria-labelledby="advanceStageTitle">
    <div class="advance-header">
      <div>
        <h2 id="advanceStageTitle" class="advance-title">{{ title }}</h2>
        <div class="advance-sub" *ngIf="performanceSubtitle">{{ performanceSubtitle }}</div>
      </div>
      <button type="button" class="advance-close" aria-label="Close" (click)="cancel()">×</button>
    </div>

    <div class="advance-content">
      <tm1-banner *ngIf="saveError" appearance="error" class="advance-banner">{{ saveError }}</tm1-banner>

      <div class="stage-block">
      <div class="stage-label">From</div>
      <div class="stage-row">
        <span class="stage-pill stage-pill--from">● {{ fromStage.label }} {{ fromStage.sub }}</span>
        <span class="stage-meta">Stage {{ fromStage.index + 1 }} of {{ totalStages }}</span>
      </div>
    </div>

    <div class="stage-block">
      <div class="stage-label">{{ isBack ? 'Back to' : 'To' }}</div>
      <div class="stage-row">
        <span class="stage-pill"
              [class.stage-pill--to]="!isBack"
              [class.stage-pill--back]="isBack">
          ● {{ toStage.label }} {{ toStage.sub }}
        </span>
        <span class="stage-meta">Stage {{ toStage.index + 1 }} of {{ totalStages }}</span>
      </div>
    </div>

    <div class="checklist-block">
      <div class="checklist-label">Confirm before {{ isBack ? 'rolling back' : 'advancing' }}</div>
      <label class="checklist-item" *ngFor="let item of checklist">
        <input type="checkbox" [(ngModel)]="item.checked" [disabled]="saving" />
        <span class="checklist-text">{{ item.text }}</span>
      </label>
    </div>

    <div class="confirm-block">
      <label class="confirm-label" for="advanceTypedConfirmation">
        Type <strong>{{ expectedConfirmationWord }}</strong> to confirm the stage change
      </label>
      <input id="advanceTypedConfirmation"
             type="text"
             class="confirm-input"
             [class.confirm-input--ok]="typedConfirmationOk()"
             [(ngModel)]="typedConfirmation"
             [disabled]="saving"
             autocomplete="off"
             [attr.placeholder]="'type ' + expectedConfirmationWord" />
    </div>

    <div class="user-note" *ngIf="currentUserEmail">
      You ({{ currentUserEmail }}) will be recorded as the user who
      {{ isBack ? 'rolled back to' : 'advanced to' }} {{ toStage.label }} {{ toStage.sub }}.
    </div>
    <div class="user-note" *ngIf="!currentUserEmail">
      Your action will be recorded in the audit trail when you
      {{ isBack ? 'roll back to' : 'advance to' }} {{ toStage.label }} {{ toStage.sub }}.
    </div>

    <div class="advance-actions">
      <tm1-button variant="outline" [disabled]="saving" (click)="cancel()">Cancel</tm1-button>
      <tm1-button variant="solid" [disabled]="!canConfirm()" (click)="confirm()">
        {{ confirmLabel }}
      </tm1-button>
    </div>
    </div>
  </div>
</div>
